
const useLogin = () => async (loginData) => {
  // with try catch block:
  try {
    const payload = {
      username: loginData.username,
      password: loginData.password,
    };

  const response = await fetch(`${process.env.REACT_APP_API_URI}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  return await response.json();
  } catch (error) {
    throw new Error(`Login request error: ${error.status}`);
  }
};

export default useLogin;
